import { render, staticRenderFns } from "./SuggestedTasksDialog.vue?vue&type=template&id=7f4b592b&scoped=true&"
import script from "./SuggestedTasksDialog.vue?vue&type=script&lang=js&"
export * from "./SuggestedTasksDialog.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedTasksDialog.vue?vue&type=style&index=0&id=7f4b592b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b592b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCardText,VDivider,VIcon,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
